import {
    aiPhotoGenerationEnabled,
    aiPhotoGenerationPromoForCreateMenu,
    aiPhotoGenerationPromoQuotaTariffFeature,
} from 'reactApp/appHelpers/featuresHelpers/features/aiPhotoGeneration';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { store as reduxStore } from 'reactApp/store';

const getBaseRequirements = (isMobile: boolean) => {
    if (!aiPhotoGenerationEnabled) {
        return false;
    }

    const state = reduxStore.getState();
    const isBizUser = UserSelectors.isBizUser(state);
    const isB2BUser = UserSelectors.isB2BUser(state);
    const isSocialUser = UserSelectors.isSocialUser(state);
    const isOverQuotaUser = UserQuotaSelectors.isOverquotaBySpaceAndApi(state);
    const isQuotaLoaded = UserQuotaSelectors.isQuotaLoaded(state);

    return !isOverQuotaUser && isQuotaLoaded && !isBizUser && !isB2BUser && !isSocialUser && !isMobile;
};

/**
 * Можем ли показывать кнопку генерации?
 */
export const getIsCanShowAiPhotoGenerationButton = (storage: EStorageType) => {
    const validStorage =
        storage === EStorageType.home ||
        storage === EStorageType.gallery ||
        storage === EStorageType.favorites ||
        storage === EStorageType.feed;

    const isMobile = EnvironmentSelectors.isMobile();

    return getBaseRequirements(isMobile) && validStorage;
};

/**
 * Можем ли показывать промку генерации в меню создания?
 */
export const getIsCanShowAiPhotoGenerationPromoForCreateMenu = () => {
    if (!aiPhotoGenerationPromoForCreateMenu) {
        return false;
    }

    const isMobile = EnvironmentSelectors.isMobile();

    return getBaseRequirements(isMobile);
};

/**
 * Можем ли показывать промки генерации на лендинге промо квоты?
 */
export const getPromoQuotaIsCanShowAiPhotoGenerationPromo = (isMobile: boolean) => {
    if (!aiPhotoGenerationPromoQuotaTariffFeature) {
        return false;
    }

    return getBaseRequirements(isMobile);
};
